import { Component } from '@angular/core';

@Component({
  selector: 'biometric-policy-v20240828',
  templateUrl: './biometric-policy-v20240828.component.html',
  styleUrls: ['./biometric-policy-v20240828.component.css']
})
export class BiometricPolicyV20240828Component {
  showPhotoVerify = false;
  verification: any;
  participant = false;
  submitting = false;

  constructor() {}

  ngOnInit(): void {}

  toggle(property: string) {
    this[property] = !this[property];
  }
}
